module.exports = __webpack_public_path__ + "static/media/katherine_ferdinand.098ae7ee.png";